import { Accordion, AccordionDetails, AccordionSummary, Backdrop, Badge, Box } from '@material-ui/core';
import { Button, Checkbox, Grid, Tooltip, Typography } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import InfoIcon from '@material-ui/icons/Info';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Draggable from 'react-draggable';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { withRouter } from 'react-router-dom';
import { getIsCaseNotAllowToUpgrade } from '../api/userTest';
import axios, { safeGet } from '../axios-default';
import ConfirmDialog from '../components/Dialog/ConfirmDialog';
import NewErrorMessageDialog from '../components/Dialog/NewErrorMessageDialog';
import LoadingSpinner from '../components/Loader/LoadingSpinner';
import Modal from '../components/Modal/modal';
import UpgradeAlignerCaseTypeModal from '../components/Modal/UpgradeAlignerCaseTypeModal';
import useAuth from '../hooks/useAuth';
import useErrorMsg from '../hooks/useErrorMsg';
import useChatUnreadCounts from '../hooks/useChatUnreadCounts';
import { clearPatientInfoData, resetAllDraftChatMsg, setPatientInfoData } from '../store/ClinicalSimulation/clinicalSimulation';
import { handleTriggerRefetch, toggle, setPatientInfoComment, setTreatmentPlanComment } from './ClinicalSimulation/RequestComment/RequestCommentSlice';
import { openModal } from '../store/Global/global';
import { easySnackbar } from '../store/Noti/noti.actions';
import { setCaseType, setIsClinicalSmulationApproveTreatmentPlan, smileDesignProductListArray } from '../store/SmileDesign/SmileDesignSlice';
import { ERROR } from '../util/const';
import { useLang } from '../util/lang';
import Chatbox from './ClinicalSimulation/components/Chatbox/Chatbox';
import Photos from './ClinicalSimulation/components/Photos/Photos';
import SmileDesignPlan from './ClinicalSimulation/components/SmileDesignPlan/SmileDesignPlan';
import ToolsMenuButton from './ClinicalSimulation/components/ToolsMenuButton/ToolsMenuButton';
import useScrollOnToggle from '../hooks/useScrollOnToggle';
import TrioIDesign from './ClinicalSimulation/components/TrioIDesign/TrioIDesign';
import RequestComment from './ClinicalSimulation/RequestComment/RequestComment';
import { canApproveTreatmentPlan } from './ClinicalSimulation/RequestComment/approvalUtils';
import './css/ClinicalSimulation.css';
import { getIsHideModifyPanel } from './PatientInfo_util';
import ClinicalApprovementModal from './SmileDesign/Modal/ClinicalApprovementModal/ClinicalApprovementModal';
import ClinicalRequestModal from './ClinicalSimulation/components/ClinicalRequestModal/ClinicalRequestModal';
import { setUpsellType } from '../store/TreatmentPlanApproval/TreatmentPlanApprovalSlice';
import { UPSELL_TYPE, UPSELL_TYPES_SHOW_EXOCAD } from '../store/TreatmentPlanApproval/TreatmentPlanApprovalSlice';
import { setImpressionData } from '../store/UploadFile/UploadFileSlice';
import _ from 'lodash';
import { useClinicalSimulationGridTemplateColumns } from '../hooks/useClinicalSimulationGridTemplateColumns';
import chatStyle from '../components/chat/chat.module.css';
import { withStyles } from '@material-ui/core/styles';
import { ApiServerUrl } from '../config.json';
import { getIsCaseNoCaseTypeUpgrade } from '../api/userTest';

const initPatientInfoData = {
    id: 0,
    first_name: '',
    last_name: '',
    case_status: '',
    case_type: '',
    isSmileDesign: false,
    upsellType: null,
};

const StyledAccordionSummary = withStyles({
    root: {
        minHeight: 52,
        padding: "0px 12px",
        '&$expanded': { minHeight: 54, },
    },
    content: {
        margin: '4px 0',
        '&$expanded': { margin: '4px 0', },
    },
    expanded: {},
})(AccordionSummary);

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    progress: {
        padding: 5,
        left: 16,
        top: 5,
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    linkBtn: {
        background: 'rgba(89,54,135,1)',
        color: 'white',
        padding: '4px 24px',
        fontWeight: 300,
        margin: '16px 0px',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            padding: '4px 72px',
            width: 'unset',
        },
        '&:hover': {
            background: 'rgb(77, 74, 142)',
            color: 'white',
        },
    },
}));

function StyledRadio(props) {
    const classes = useStyles();
    return (
        <Radio
            className={classes.root}
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

function ClinicalSimulation() {
    const dispatch = useDispatch();
    const { isShowComment: comment, triggerRefetch } = useSelector((state) => state.requestComment);
    const { isIDesign, isExocad, isMaximizeIDesign, refreshApiByUpdateRequest } = useSelector(
        (state) => state.smileDesign
    );
    const treatmentPlanApproval = useSelector((state) => state.treatmentPlanApproval);
    const { total } = useSelector((store) => store.clinicalSimulation.unreadCounts);

    const auth = useAuth();
    const currentUserRole = auth.user.role;
    // 判断当前用户是否为 Sadmin，用于控制 RequestComment 默认关闭。
    const isSAdminRole = currentUserRole === 'SADMIN';
    const currentUserAuthToken = auth.user.user_id; // User id used as auth token;

    const { getErrorMsg } = useErrorMsg();
    const history = useHistory();

    useEffect(() => {
        const html = document.documentElement;
        const body = document.body;
        const prevHtmlOverflow = html.style.overflow;
        const prevBodyOverflow = body.style.overflow;

        html.style.overflow = 'hidden';
        body.style.overflow = 'hidden';

        return () => {
            html.style.overflow = prevHtmlOverflow;
            body.style.overflow = prevBodyOverflow;
        };
    }, []);

    const checkIDesignTwoMyoFileIsExist = async (file) => {
        let isExist = false;
        const newIDesignLink = process.env.REACT_APP_IDESIGN_LINK;
        const isNewIDesignVersion = file.url.includes(newIDesignLink);
        if (isNewIDesignVersion) {
            try {
                const planId = file.plan_id;
                const isMyoFileIsExist = await axios.get(`case/check_myo_file_is_exist/${planId}`);
                const data = isMyoFileIsExist.data;
                isExist = data.isExist;
                return isExist;
            } catch (e) {
                return false;
            }
        } else {
            return false;
        }
    };

    const classes = useStyles();
    const [downloading, setDownloading] = useState(false),
        [treatmentPlan, setTreatmentPlan] = useState([]),
        [confirmOpenNextAligner, setConfirmOpenNextAligner] = useState(false),
        [currentTreatmentPlan, setCurrentTreatmentPlan] = useState({}),
        [currentTreatmentPlanList, setCurrentTreatmentPlanList] = useState([]),
        [chatRomWidth, setChatRomWidth] = useState(3),
        [hideTabs, setHideTabs] = useState(false),
        [showPhotosWidth, setShowPhotosWidth] = useState(8),
        [hideSimulation, setHideSimulation] = useState(false),
        [draggable, setDraggable] = useState(false),
        [photosDraggable, setPhotosDraggable] = useState(false),
        [exitFullScreen, setExitFullScreen] = useState(false),
        [dragPosition, setDragPosition] = useState(false),
        [enableDistrAlert, setEnableDistrAlert] = useState(false),
        [distrAlertMsg1, setDistrAlertMsg1] = useState(false),
        [distrAlertMsg2, setDistrAlertMsg2] = useState(false),
        [distrData, setDistrData] = useState([]),
        [distrMissingMsg, setDistrMissingMsg] = useState(true),
        [patientInfo, setPatientInfo] = useState(initPatientInfoData),
        [showPhotos, setShowPhotos] = useState(false),
        [showTrioIDesign, setShowTrioIDesign] = useState(true),
        [showChatbox, setShowChatbox] = useState(true), // default always open
        [showErrorMessage, setShowErrorMessage] = useState(false),
        [caseFiles, setCaseFiles] = useState([]),
        [promotionCode, setPromotionCode] = useState(''),
        [isPromotionCodeValid, setIsPromotionCodeValid] = useState(true),
        [iDesignTwoShowDownloadBtn, setiDesignTwoShowDownloadBtn] = useState(false),
        [isShowSmileDesignFeature, setIsShowSmileDesignFeature] = useState(false),
        [isOpenLiveSupportTicketModal, setIsOpenLiveSupportTicketModal] = useState(false),
        [isloaded, setIsloaded] = useState(false),
        [openUpgradeTreatmentPlanModal, setOpenUpgradeTreatmentPlanModal] = useState(false),
        [isProcessing, setIsProcessing] = useState(false),
        [switchPositionOfiDesignAndSmileDesign, setSwitchPositionOfiDesignAndSmileDesign] = useState(false),
        [requestModalOpen, setRequestModalOpen] = useState(false),
        [isShowRequestUpgradeButton, setShowRequestUpgradeButton] = useState(false),
        [isCompactToolbar, setIsCompactToolbar] = useState(false);
    const isCaseStatusUpload = patientInfo?.case_status === 'PLAN_UPLOADED';
    const isPatientSmileDesignHave =
        !!patientInfo.isSmileDesign ||
        [UPSELL_TYPE.ALIGN_FIRST_Q16, UPSELL_TYPE.ALIGN_AND_RESTORE_Q14_AND_Q16].includes(patientInfo.upsellType);
    const isISDCase = smileDesignProductListArray.includes(patientInfo.case_type);
    const canApproveCurrentISDPlan =
        currentUserRole === 'DR' &&
        isISDCase &&
        canApproveTreatmentPlan({
            planId: currentTreatmentPlan?.plan_id,
            treatmentPlans: treatmentPlan,
            caseStatus: patientInfo.case_status,
        });

    const renderRequestUpgradeButton = () => {
        if (
            !['DR'].includes(currentUserRole) ||
            !patientInfo?.case_type ||
            !smileDesignProductListArray.includes(patientInfo.case_type)
        ) {
            return null;
        }
        
        return (
            <Box style={{margin: "6px 8px 0 0"}} display="flex" justifyContent="flex-end">
                <Button
                    disabled={!isCaseStatusUpload}
                    type="button"
                    size="small"
                    variant="contained"
                    style={{
                        background: '#39a8bd',
                        color: '#fff',
                        fontSize: '12px',
                        fontWeight: 600,
                        padding: '6px 20px',
                        maxWidth: '220px',
                        lineHeight: 1.2,
                        borderRadius: '8px',
                        opacity: !isCaseStatusUpload ? 0.5 : 1,
                    }}
                    onClick={() => setRequestModalOpen(true)}
                >
                    Request / Upgrade TrioClear Treatment Plan
                </Button>
            </Box>
        );
    };

    const sidebarRef = React.useRef(null);
    const commentBoxScrollRef = useScrollOnToggle(comment, sidebarRef);
    const chatboxScrollRef = useScrollOnToggle(showChatbox, sidebarRef);
    const [chatboxExpanded, setChatboxExpanded] = useState(!['DR'].includes(currentUserRole));
    useEffect(() => {
        if (showChatbox) setChatboxExpanded(true);
    }, [showChatbox]);

    const { id: caseId, plan_id, patientsid: patientId } = useParams();

    const get = useLang('PatientInfo');

    // Single shared WebSocket — provides message arrays for Chat UI + unread counts for Redux.
    // Eliminates the need for a second socket inside the Chat component.
    const handleDeleteMessageError = React.useCallback(
        ({ msgKey }) => {
            dispatch(
                openModal({
                    modalMessage: get(`clinicalSimulation.msg.${msgKey || 'FAILED_TO_DELETE_CHAT_MESSAGE_CID'}`),
                    showOk: false,
                })
            );
        },
        [dispatch, get]
    );
    
    const { socketRef, chatRoomMessages, privateChatMessages, intlChatMessages, loadingMessages } = useChatUnreadCounts(
        caseId,
        { onDeleteMessageError: handleDeleteMessageError }
    );

    useEffect(() => {
        document.title = 'Clinical Simulation';
        axios
            .get(`distrmsg/getdistrmsg`)
            .then((res) => {
                setDistrData(res.data.dm);
            })
            .catch((error) => {
                console.error(error);
            });

        return () => {
            dispatch(resetAllDraftChatMsg());
        };
    }, []);

    useEffect(() => {
        if (enableDistrAlert) {
            if (distrAlertMsg1 && distrAlertMsg2) {
                setDistrMissingMsg(false);
            } else {
                setDistrMissingMsg(true);
            }
        }
    }, [distrAlertMsg1, distrAlertMsg2]);

    useEffect(() => {
        axios
            .get(`case/treatment_plan/${caseId}/clinicalSimulation`)
            .then((res) => {
                if (res.data.treatment_plan.length && res.data.treatment_plan?.[0]?.[0]) {
                    const curTp = res.data.treatment_plan.slice(-1)[0];
                    setCurrentTreatmentPlanList(curTp);
                    if (isNaN(plan_id)) {
                        setCurrentTreatmentPlan(curTp.find((v) => v.approved_flag) ?? curTp.slice(-1)[0]);
                    } else {
                        res.data.treatment_plan.flat(3).some((plan) => {
                            if (plan.plan_id == parseInt(plan_id)) {
                                setCurrentTreatmentPlan(plan);
                            }
                        });
                    }
                    setTreatmentPlan(res.data.treatment_plan);
                    dispatch(setTreatmentPlanComment(res.data.treatment_plan));
                }
            })
            .catch((error) => {
                console.error(error);
            });

        axios
            .get(`/case/simulation_chat/${caseId}`)
            .then((res) => {
                if (res.status === 200 && res.data && res.data.success && res.data.data) {
                    const data = res.data.data;
                    const { case_file } = data;
                    if (Array.isArray(case_file) && case_file.length > 0) {
                        setCaseFiles(case_file);
                    }
                    if (data?.case) {
                        const caseData = data.case;
                        let patientInfoData = {
                            id: caseData.case_id,
                            first_name: caseData.first_name,
                            last_name: caseData.last_name,
                            case_status: caseData.case_status,
                            case_type: caseData.case_type,
                            isSmileDesign: caseData.isSmileDesign,
                            upsellType: data?.shouldApproveUpsellData?.upsellType || null,
                        };
                        if (data?.shouldApproveUpsellData) {
                            const { shouldApproveUpsellPart, upsellType } = data.shouldApproveUpsellData;
                            dispatch(
                                setUpsellType({
                                    upsellType: upsellType || null,
                                    shouldApproveUpsellPart: shouldApproveUpsellPart || false,
                                })
                            );
                        }

                        // const isAdminRole = ADMIN_ROLES.includes(currentUserRole);
                        // if (isAdminRole) {
                        //     dispatch(toggle(false));
                        // }

                        // if ((caseData?.case_type && caseData?.case_type === 'RETAINER') || isAdminRole) {
                        //     setShowChatbox(true);
                        // }

                        if (!['DR', 'DISTR',].includes(currentUserRole)) {
                            console.log(currentUserRole, 'currentUserRole');
                            dispatch(toggle(false));
                        }

                        // For DR role - Default hide Live Chat Box
                        if (['DR'].includes(currentUserRole)) {
                            console.log(currentUserRole, 'currentUserRole');
                            setShowChatbox(false);
                        }

                        setPatientInfo(patientInfoData);
                        dispatch(setPatientInfoData(patientInfoData));

                        let promotionCode = caseData?.promotion_code || '';
                        setPromotionCode(promotionCode);

                        const isAlignerUpsellISDCase = [
                            UPSELL_TYPE.ALIGN_FIRST_Q16,
                            UPSELL_TYPE.ALIGN_AND_RESTORE_Q14_AND_Q16,
                        ].includes(patientInfoData.upsellType);
                        const shouldDefaultOpenISDViewer =
                            ['DR', 'DISTR', 'SADMIN'].includes(currentUserRole) &&
                            (patientInfoData.isSmileDesign || isAlignerUpsellISDCase);
                        const isShowSmileDesignFeature = shouldDefaultOpenISDViewer;
                        setIsShowSmileDesignFeature(isShowSmileDesignFeature);
                        if (!isSAdminRole && !(['DR'].includes(currentUserRole) && isShowSmileDesignFeature)) dispatch(toggle(true));;
                        dispatch(setCaseType(patientInfoData.case_type));

                        setIsloaded(true);
                        dispatch(setPatientInfoComment(patientInfoData));
                    }
                }
            })
            .catch((err) => {
                console.error(err);
                if (err.response && err.response.data && err.response.data.message) {
                    if (err.response.data.message === ERROR.CASE_CANCELLED) {
                        dispatch(
                            openModal({
                                modalTitle: get('@PatientInfo.msg.caseCancelledTitle'),
                                modalMessage: get('@PatientInfo.msg.caseCancelledMessage'),
                                modalOnCloseCallbackFunc: () => history.push('/'),
                                showOk: false,
                            })
                        );
                    }
                    if (err.response.data.message === ERROR.SELF_DESIGN_CASE) {
                        dispatch(
                            openModal({
                                modalTitle: get('@PatientInfo.msg.selfDesignCaseTitle'),
                                modalMessage: get('@PatientInfo.msg.selfDesignCaseMessage'),
                                modalOnCloseCallbackFunc: () => history.push('/'),
                                showOk: false,
                            })
                        );
                    }
                }
            });

        return () => {
            dispatch(clearPatientInfoData());
        };
    }, [triggerRefetch, refreshApiByUpdateRequest, auth?.user]);

    useEffect(() => {
        if (patientInfo.isSmileDesign) {
            return;
        }
        if (patientInfo.upsellType && UPSELL_TYPES_SHOW_EXOCAD.includes(patientInfo.upsellType)) {
            let isExocadValid =
                currentTreatmentPlan?.smileDesign_exocad_pre?.length > 0 &&
                currentTreatmentPlan?.smileDesign_exocad_pre_name?.length > 0;
            if (isExocadValid && !isShowSmileDesignFeature) {
                setIsShowSmileDesignFeature(true);
            }
        }
    }, [currentTreatmentPlan, patientInfo]);

    // const isExocadReady = useMemo(() => {
    //     let show = false;
    //     if (patientInfo && patientInfo?.isSmileDesign && currentTreatmentPlan) {
    //         let isExocadValid =
    //             currentTreatmentPlan?.smileDesign_exocad_pre?.length > 0 &&
    //             currentTreatmentPlan?.smileDesign_exocad_pre_name?.length > 0;
    //         show = isExocadValid;
    //     }
    //     return show;
    // }, [currentTreatmentPlan, patientInfo]);

    useEffect(() => {
        if (currentTreatmentPlan != null && Object.keys(currentTreatmentPlan).length != 0) {
            const checkMyoFunc = async (currentTreatmentPlan) => {
                if (currentTreatmentPlan != null && Object.keys(currentTreatmentPlan).length !== 0) {
                    try {
                        const result = await checkIDesignTwoMyoFileIsExist(currentTreatmentPlan);
                        setiDesignTwoShowDownloadBtn(result);
                    } catch (error) {
                        console.error('Error fetching data:', error);
                    }
                }
            };

            checkMyoFunc(currentTreatmentPlan);
        }
    }, [currentTreatmentPlan]);

    const handleProcessNextSet = (val) => {
        setConfirmOpenNextAligner(val);
    };

    const handleChangeStatusUpdate = async (value) => {
        try {
            await axios.post(`case/status/${caseId}/${value}`, { caseId: caseId, newStatus: value });
            window.location.reload();
        } catch (err) {
            const errMsg = getErrorMsg(err, 'Error updating case status');
            dispatch(easySnackbar(errMsg, 'error'));
            console.error('error', err.response);
        }
    };

    const handleCurrentTreatmentPlan = (value) => {
        treatmentPlan.flat(3).some((plan) => {
            if (plan.plan_id === Number(value)) {
                setCurrentTreatmentPlan(plan);
                return true;
            }
            return false;
        });
    };

    const handleApproveTreatmentPlanByCaseType = async (plan_id) => {
        const isNoCaseTypeUpgrade = await getIsCaseNoCaseTypeUpgrade(caseId, plan_id);
        if (smileDesignProductListArray.includes(patientInfo.case_type)) {
            dispatch(setIsClinicalSmulationApproveTreatmentPlan(true));
            return;
        } else if (isNoCaseTypeUpgrade) {
            handleApprovePlan(plan_id);
            return;
        } else {
            setOpenUpgradeTreatmentPlanModal(true);
            return;
        }
    };

    /**
     * Starts approval for the active ISD treatment plan from the toolbar.
     */
    const handleTopApproveTreatmentPlan = () => {
        handleApproveTreatmentPlanByCaseType(currentTreatmentPlan.plan_id);
    };

    const handleApprovePlan = async (plan_id) => {
        // let isValid = true;
        if (promotionCode) {
            // const promotionCodeValidRes = await axios.get(`/case/promotionCode/invalid/${caseId}`);
            // isValid = promotionCodeValidRes.data.valid;
            // setIsPromotionCodeValid(promotionCodeValidRes.data.valid);
            setIsPromotionCodeValid(true);
        }

        if (distrData.length > 0 && distrData[0].enable_flag === true && !enableDistrAlert) {
            //enableDistrAlertModel
            setEnableDistrAlert(true);
            // } else if ((distrData.length === 0 || distrData[0].enable_flag === false) && !enableDistrAlert && !isValid) {
            //   setDistrAlertMsg1(true);
            //   setDistrAlertMsg2(true);
            //   setDistrMissingMsg(false);
            //   setEnableDistrAlert(true)
        } else {
            const question = 'Are you sure you want to approve this treatment plan?';
            let result = window.confirm(question);
            if (result) {
                handlePostApprovePlan(plan_id, isPromotionCodeValid && !promotionCode.includes('Invalid'));
            }
        }
    };

    const handlePostApprovePlan = async (plan_id) => {
        setIsProcessing(true);
        try {
            let { data } = await axios.post(`case/${caseId}/treatment_plan/${plan_id}/approve`, {
                caseId: caseId,
                planId: plan_id,
            });
            // if (isValid) {
            if (promotionCode && promotionCode.length) {
                await axios.post(`/case/promotionCode/uselog/${caseId}`, {
                    promotionCode: promotionCode,
                });
                // } else {
                //   await axios.post(`/case/promotionCode/invalid/${caseId}`);
            }
            if (data.success) {
                window.location.reload();
            }
        } catch (e) {
            setIsProcessing(false);
            console.error(e.response);
            let errorMessage = 'Something Went Wrong Please Connect With Admin';
            if (e.response && e.response.data && e.response.data.message) {
                if (e.response.data.message === ERROR.CASE_CANCELLED) {
                    dispatch(
                        openModal({
                            modalTitle: get('@PatientInfo.msg.caseCancelledTitle'),
                            modalMessage: get('@PatientInfo.msg.caseCancelledMessage'),
                            modalOnCloseCallbackFunc: () => history.push('/'),
                            showOk: false,
                        })
                    );
                    return;
                }
                errorMessage = e.response.data.message;
            }
            dispatch(easySnackbar(errorMessage, 'error'));
        } finally {
            setIsProcessing(false);
        }
    };

    const handleChecked = (field, value) => {
        if (field === 'msg1') {
            setDistrAlertMsg1(value);
        }
        if (field === 'msg2') {
            setDistrAlertMsg2(value);
        }
    };

    const handleNewChatRoom = () => {
        setHideTabs(true);
    };
    const handleSmallChatRoom = () => {
        setHideTabs(false);
        setHideSimulation(false);
    };
    const handleVerticalSplit = () => {
        setHideSimulation((hideSimulation) => !hideSimulation);
    };
    const dragableChatRoom = () => {
        setDraggable((draggable) => !draggable);
        setShowPhotosWidth(11);

        if (chatRomWidth === 0) {
            setShowPhotosWidth(8);
            setChatRomWidth(3);
        }

        if (chatRomWidth === 3) {
            setChatRomWidth(0);
        }
        // dragPosition, setDragPosition
        setDragPosition((dragPosition) => !dragPosition);
    };
    // Fullscreen Simulation
    const handleFullScreen = () => {
        setExitFullScreen((exitFullScreen) => !exitFullScreen);
    };

    const threeDimensionLink = React.useMemo(() => {
        const url = currentTreatmentPlan && currentTreatmentPlan.url ? currentTreatmentPlan.url.trim() : false;
        if (url) {
            // Flag for hiding modify panel in simulation
            let hideModifyPanel = false;
            // Always show modify panel for admin users
            // const isNonAdminUser = !['SADMIN', 'ADMIN'].includes(JSON.parse(localStorage.getItem('role')));
            const isNonAdminUser = !['SADMIN', 'ADMIN'].includes(currentUserRole);
            // For non-admin users, hide the modify panel if the case status is not PLAN_UPLOADED or the treatment plan is approved
            if (isNonAdminUser) {
                hideModifyPanel = getIsHideModifyPanel(patientInfo.case_status, currentTreatmentPlan.approved_flag);
            }
            let queryString = '';
            if (
                /3d\.trioclear\.com(\.cn)?/.test(url) ||
                /.+test3d/.test(url) ||
                /idesignview\./.test(url) ||
                /idesignviewdev\./.test(url)
            ) {
                // queryString =
                //     '&userid=' +
                //     JSON.parse(localStorage.getItem('auth-token')) +
                //     (hideModifyPanel ? '&modifyHide=true' : '');
                queryString = '&userid=' + currentUserAuthToken + (hideModifyPanel ? '&modifyHide=true' : '');
            } else if (
                (hideModifyPanel || patientInfo.isSmileDesign) &&
                (/^https?:\/\/.*smartcheck/.test(url) || /idesign\./.test(url) || /idesigndev\./.test(url))
            ) {
                queryString = hideModifyPanel ? '&hidden=1' : '';
            }
            return (/^https?:\/\//.test(url) ? '' : 'https://') + url + queryString;
        }
        return null;
    }, [currentTreatmentPlan, patientInfo]);

    // Handle drag and drop for photos
    const handleDragStartAndEnd = () => {
        setPhotosDraggable(!photosDraggable);
        setShowPhotos(!showPhotos);
    };

    // Get the window width
    const currentWindowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    const sectionsCommonHeight = 'calc(100vh - 109px)';
    // const sectionsCommonHeight = '820px';

    // Conditions For layout change
    const showPhotosPanel = showPhotos && !photosDraggable;
    const showTrioPanel = showTrioIDesign;
    const showCommentsPanel = comment || showChatbox;
    const showSmilePanel = isShowSmileDesignFeature;

    // Comment box fix width (450px)
    const showCondition_C = !showPhotosPanel && !showTrioPanel && showCommentsPanel && !showSmilePanel; // comment
    const showCondition_I = !showPhotosPanel && showTrioPanel && !showCommentsPanel && !showSmilePanel; // idesign
    const showCondition_S = !showPhotosPanel && !showTrioPanel && !showCommentsPanel && showSmilePanel; // smile
    const showCondition_P = showPhotosPanel && !showTrioPanel && !showCommentsPanel && !showSmilePanel; // photos
    const showCondition_PICS = showPhotosPanel && showTrioPanel && showCommentsPanel && showSmilePanel; // photos-idesign-smile-comment
    const showCondition_IC = !showPhotosPanel && showTrioPanel && showCommentsPanel && !showSmilePanel; // idesign-comment
    const showCondition_CS = !showPhotosPanel && !showTrioPanel && showCommentsPanel && showSmilePanel; // comment-smile
    const showCondition_ISC = !showPhotosPanel && showTrioPanel && showCommentsPanel && showSmilePanel; // idesign-smile-comment
    const showCondition_PIC = showPhotosPanel && showTrioPanel && showCommentsPanel && !showSmilePanel; // photos-idesign-comment
    const showCondition_PSC = showPhotosPanel && !showTrioPanel && showCommentsPanel && showSmilePanel; // photos-smile-comment
    const showCondition_PCS = showPhotosPanel && !showTrioPanel && showCommentsPanel && showSmilePanel; // photos-smile-comment
    const showCondition_PIS = showPhotosPanel && showTrioPanel && !showCommentsPanel && showSmilePanel;  // photos-idesign-smile
    
    const onlyTrioIDesignVisible = showCondition_I;
    const hasVisiblePanelAfterTrioIDesign = switchPositionOfiDesignAndSmileDesign
        ? showCommentsPanel && (showCondition_ISC || showCondition_PICS)
        : showCommentsPanel || showSmilePanel;
    const isTrioIDesignRightmost =
        showTrioIDesign && !onlyTrioIDesignVisible && !hasVisiblePanelAfterTrioIDesign;
    const isSpecialTrioIDesignLayout = onlyTrioIDesignVisible || isTrioIDesignRightmost;
    const { gridTemplateColumns, gridTemplateArray } = useClinicalSimulationGridTemplateColumns({
        hideTabs,
        showCondition_C,
        showCondition_I,
        showCondition_S,
        showCondition_P,
        showCondition_PICS,
        showCondition_IC,
        showCondition_CS,
        showCondition_ISC,
        showCondition_PIC,
        showCondition_PSC,
        showCondition_PCS,
        showCondition_PIS,
    });
     const commentSidebarGridStyle = useMemo(
        () => ({
            height:isCompactToolbar === true ? 'calc(-80px + 100vh)' : sectionsCommonHeight,
            ...(isCompactToolbar === true ? { marginTop: '-29px' } : {}),
        }),
        [isCompactToolbar, sectionsCommonHeight]
    );
    const smileDesignPlanGridStyle = useMemo(
        () => {
            if (!isTrioIDesignRightmost) {
                return commentSidebarGridStyle;
            }
            const { marginTop, ...restStyle } = commentSidebarGridStyle;
            return restStyle;
        },
        [commentSidebarGridStyle, isTrioIDesignRightmost]
    );
    const switchTrioIDesignstyle = useMemo(
        () => ({
                height:isCompactToolbar === true ? '' : 'calc(100vh - 108.5px)',
                ...(isCompactToolbar === true ? { marginTop: '-109px' } : {}),
            }),
        [isCompactToolbar, sectionsCommonHeight]
    );
    const trioIDesignContainerStyle = useMemo(
        () => {
            if (!isTrioIDesignRightmost) {
                return switchTrioIDesignstyle;
            }
            const { marginTop, ...restStyle } = switchTrioIDesignstyle;
            return restStyle;
        },
        [isTrioIDesignRightmost, switchTrioIDesignstyle]
    );
    const trioIDesignIframeStyle = useMemo(() => {
        if (onlyTrioIDesignVisible) {
            return {
                top: 0,
            };
        }
        if (isTrioIDesignRightmost) {
            return {
                top: '-80px',
            };
        }
        return {};
    }, [onlyTrioIDesignVisible, isTrioIDesignRightmost]);
    const handleCompactToolbarChange = useCallback((nextIsCompactToolbar) => {
        setIsCompactToolbar((previousIsCompactToolbar) =>
            previousIsCompactToolbar === nextIsCompactToolbar ? previousIsCompactToolbar : nextIsCompactToolbar
        );
    }, []);
    // const handleCloseUpsellRestorationModal = () => {
    //     setUpsellRestorationFormOpen(false);
    //     dispatch(setUpsellRestorationFormData(null));
    //     dispatch(setUpsellPlanId(null));
    //     dispatch(setImpressionData({}));
    // };

    useEffect(() => {
        if (['SADMIN', 'ADMIN'].includes(currentUserRole)) setHideTabs(true);
    }, []);

    useEffect(() => {
        if (currentTreatmentPlan && currentTreatmentPlan?.plan_id) {
            history.replace(`/clinicalSimulation/${caseId}/plan/${currentTreatmentPlan.plan_id}?treatmentPlan=${currentTreatmentPlan.plan_no}`);
        }
    }, [currentTreatmentPlan]);

    useEffect(() => {
        if (!isShowSmileDesignFeature || !showTrioIDesign) {
            setSwitchPositionOfiDesignAndSmileDesign(false);
        }
    }, [isShowSmileDesignFeature, showTrioIDesign]);

    useEffect(() => {
        const handleAllowedUpgradeResponse = async () => {
            try {
                const allowedUpgradeResponse = await axios.get(`/case/smileDesign/allowedUpgrade/${caseId}`);
                const { comprehensive, twelveStep } = allowedUpgradeResponse.data.result;
                setShowRequestUpgradeButton(comprehensive);
            } catch (e) {
                setShowRequestUpgradeButton(false);
            }
        };

        if (isCaseStatusUpload) {
            handleAllowedUpgradeResponse();
        }
    }, [patientInfo]); 

    return (
        <Box style={{ height: "100vh", }}>
            {/* <RestorationToolFormModal
                open={upsellRestorationFormOpen}
                isMarieGroup={isMarieGroup}
                handleClose={() => handleCloseUpsellRestorationModal()}
                caseId={caseId}
                onSuccess={(planId) => handleSuccessApproveUpsellTP(planId)}
                onError={(error) => handleErrorApproveUpsellTP(error)}
            /> */}

            <Backdrop style={{ zIndex: 9999, color: '#fff' }} open={isProcessing}>
                <LoadingSpinner />
            </Backdrop>

            {smileDesignProductListArray.includes(patientInfo.case_type) ? (
                <>
                    <ClinicalApprovementModal caseId={caseId} planId={currentTreatmentPlan.plan_id} />
                </>
            ) : (
                <UpgradeAlignerCaseTypeModal
                    openExtenal={openUpgradeTreatmentPlanModal}
                    handleOpenExternal={() => setOpenUpgradeTreatmentPlanModal(false)}
                    planId={currentTreatmentPlan?.plan_id}
                    caseId={caseId}
                />
            )}

            <ClinicalApprovementModal
                caseId={caseId}
                planId={currentTreatmentPlan.plan_id}
            />

            <NewErrorMessageDialog
                title="Error Message"
                open={showErrorMessage}
                setOpen={setShowErrorMessage}
                onOk={() => {
                    setShowErrorMessage(false);
                }}
                backgroundColor="#593687"
            >
                <p>At least one of the following items should be shown on webpage:</p>
                <ul>
                    <li>Photos</li>
                    <li>Trio iDesign</li>
                    <li>Chatbox</li>
                </ul>
            </NewErrorMessageDialog>
            <Modal
                className="modal"
                modal="Distr form"
                title="Trioclear Platform Message"
                open={enableDistrAlert}
                handleClose={() => {
                    setDistrMissingMsg(true);
                    setEnableDistrAlert(false);
                }}
                handleDataSave={() => {
                    distrAlertMsg1 && distrAlertMsg2
                        ? handleApprovePlan(currentTreatmentPlan.plan_id)
                        : setDistrMissingMsg(true);
                }}
                submitButton={true}
            >
                {distrData.length > 0 && distrData[0].enable_flag === true ? (
                    <>
                        <FormControlLabel
                            control={<Checkbox checked={distrAlertMsg1} />}
                            label={distrData[0] && distrData[0].msg1}
                            labelPlacement="end"
                            onChange={(e) => handleChecked('msg1', e.target.checked)}
                        />
                        <br />
                        <FormControlLabel
                            control={<Checkbox checked={distrAlertMsg2} />}
                            label={distrData[0] && distrData[0].msg2}
                            labelPlacement="end"
                            onChange={(e) => handleChecked('msg2', e.target.checked)}
                        />
                    </>
                ) : (
                    ''
                )}
                {!isPromotionCodeValid || (promotionCode && promotionCode.includes('Invalid')) ? (
                    <>
                        <p>
                            The promotion code you entered was not valid. Please note that the promotion code can only
                            be used once.
                        </p>
                        <p>Do you still want to confirm the treatment plan?</p>
                    </>
                ) : (
                    <p>Confirm to approve the Treatment plan?</p>
                )}
                <br />
                {distrMissingMsg && <p>Please accept the above statement</p>}
            </Modal>
             {!onlyTrioIDesignVisible && (
                <>
                    {/* Top bar */}
                    <Box
                        sx={{
                            background: 'rgb(83, 42, 116)',
                            color: 'white',
                            height: '32px',
                            textAlign: 'center',
                            fontSize: '12px',
                            fontWeight: 600,
                            position: onlyTrioIDesignVisible ? 'fixed' : 'relative',
                            top: onlyTrioIDesignVisible ? 0 : 'auto',
                            left: onlyTrioIDesignVisible ? 0 : 'auto',
                            zIndex: onlyTrioIDesignVisible ? 1 : isTrioIDesignRightmost ? 0 : 'auto',
                            width: onlyTrioIDesignVisible ? '300px' : 'auto',
                            borderBottom: '2px solid rgba(115, 124, 175, 0.7)',
                            boxSizing: 'border-box',
                        }}
                    >
                        <Box
                            style={{
                                display: 'flex',
                                gap: '16px',
                                marginRight: isSpecialTrioIDesignLayout ? 0 : '16px',
                                marginLeft: isSpecialTrioIDesignLayout ? '16px' : 0,
                                height: '100%',
                                alignItems: 'center',
                                justifyContent: isSpecialTrioIDesignLayout ? 'flex-start' : 'flex-end',
                            }}
                        >
                            <Box style={{ display: "flex", alignItems: "center", marginRight: "10px" }}>
                                {JSON.parse(localStorage.getItem('userInfoName')) ?? ""}
                            </Box>
                            <Box style={{ display: "flex", alignItems: "center" }} >
                                <Tooltip
                                    title={
                                        <div style={{ margin: 10 }}>
                                            <div style={{ fontSize: '15px', lineHeight: '1' }}>
                                                {get('@PatientInfo.msg.commentTip')}
                                            </div>
                                        </div>
                                    }
                                >
                                    <InfoIcon style={{ color: '#f2f2f2', fontSize: '20px', }} />
                                </Tooltip>
                            </Box>
                            <Box
                                style={{ display: "flex", alignItems: "center" }}
                                id="refresh-btn"
                                onClick={() => {
                                    dispatch(handleTriggerRefetch());
                                }}
                            >
                                <RefreshIcon style={{ color: '#f2f2f2', fontSize: '24px', }} />
                            </Box>
                        </Box>
                    </Box>
                </>
            )}
            {/* Top gray bar */}
            <ToolsMenuButton
                showPhotos={showPhotos}
                showTrioIDesign={showTrioIDesign}
                isShowSmileDesignFeature={isShowSmileDesignFeature}
                comment={comment}
                showChatbox={showChatbox}
                switchPositionOfiDesignAndSmileDesign={switchPositionOfiDesignAndSmileDesign}
                setShowPhotos={setShowPhotos}
                setShowTrioIDesign={setShowTrioIDesign}
                setIsShowSmileDesignFeature={setIsShowSmileDesignFeature}
                setShowChatbox={setShowChatbox}
                setSwitchPositionOfiDesignAndSmileDesign={setSwitchPositionOfiDesignAndSmileDesign}
                setCommentBox={(checked) => {
                    dispatch(toggle(checked));
                }}
                isloaded={isloaded}
                isPatientSmileDesignHave={isPatientSmileDesignHave}
                currentTreatmentPlan={currentTreatmentPlan}
                canApproveCurrentISDPlan={canApproveCurrentISDPlan}
                handleTopApproveTreatmentPlan={handleTopApproveTreatmentPlan}
                gridTemplateArray={gridTemplateArray}
                setIsCompactToolbar={handleCompactToolbarChange}
                onlyTrioIDesignVisible={onlyTrioIDesignVisible}
                isTrioIDesignRightmost={isTrioIDesignRightmost}
            />
            <div>
                <Grid
                    container
                    style={{
                        display: 'grid',
                        gap: 0,
                        justifyContent: 'end',
                        gridTemplateColumns: gridTemplateColumns,
                        ...(isTrioIDesignRightmost ? { borderTop: '48px solid #eeeeef' } : {}),
                    }}
                    className={`responsive-grid-clinicalSimulation ${showCondition_IC && 'only-two-box-active'}`}
                >
                    <>
                        {/* Photo Viewer */}
                        {photosDraggable ? (
                            <Draggable
                                handle="#draggable-photo-title"
                                cancel={'[class*="MuiDialogContent-root"]'}
                                onDragStart={() => handleDragStartAndEnd()}
                                onDragEnd={() => handleDragStartAndEnd()}
                            >
                                <div
                                    id="draggable-photo-title"
                                    style={{
                                        height: '70svh',
                                        width: '80svw',
                                        maxWidth: '500px',
                                        overflow: 'auto',
                                        backgroundColor: '#fff',
                                        zIndex: 99,
                                        position: 'fixed',
                                        border: '2px solid #504d94',
                                        borderRadius: 4,
                                        cursor: 'move',
                                        padding: '10px',
                                    }}
                                >
                                    <Photos
                                        caseId={caseId}
                                        handleDragStartAndEnd={handleDragStartAndEnd}
                                        photosDraggable={photosDraggable}
                                        caseFiles={caseFiles}
                                    />
                                </div>
                            </Draggable>
                        ) : showPhotos ? (
                            <Grid
                                item
                                style={{
                                    display: !showPhotos ? 'none' : 'grid',
                                    maxHeight: 'calc(-80px + 100vh)',
                                    minHeight: isTrioIDesignRightmost ? 'calc(-80px + 100vh)' : photosDraggable ? sectionsCommonHeight : 0,
                                    overflow: 'auto',
                                    backgroundColor: '#fff',
                                    zIndex: 99,
                                    padding: '10px',
                                    gridTemplateRows: 'auto 1fr',
                                    marginTop: (isTrioIDesignRightmost === false  && isCompactToolbar === true)? '-29px' : 0,
                                    // Common style for height
                                }}
                            >
                                <Photos
                                    caseId={caseId}
                                    handleDragStartAndEnd={handleDragStartAndEnd}
                                    photosDraggable={photosDraggable}
                                    caseFiles={caseFiles}
                                />
                            </Grid>
                        ) : (
                            <></>
                        )}

                        {/* On switch treatment plan change the component positions */}
                        {switchPositionOfiDesignAndSmileDesign ? (
                            <>
                                {/* Smile Design */}
                                {isShowSmileDesignFeature && (
                                    <Grid item>
                                        <SmileDesignPlan
                                            useStyles={useStyles}
                                            currentTreatmentPlan={currentTreatmentPlan}
                                            patientInfo={patientInfo}
                                            commentSidebarGridStyle={smileDesignPlanGridStyle}
                                        />
                                    </Grid>
                                )}
                            </>
                        ) : (
                            <>
                                {/* Trio IDesign */}
                                {showTrioIDesign && (
                                    <Grid
                                        item
                                        style={{
                                            padding: 0,
                                        }}
                                    >
                                        <TrioIDesign
                                            caseId={caseId}
                                            patientInfo={patientInfo}
                                            currentTreatmentPlan={currentTreatmentPlan}
                                            iDesignTwoShowDownloadBtn={iDesignTwoShowDownloadBtn}
                                            threeDimensionLink={threeDimensionLink}
                                            useStyles={useStyles}
                                            currentUserRole={currentUserRole}
                                            isTopPositionNormal={
                                                showCondition_I ||
                                                !threeDimensionLink ||
                                                switchPositionOfiDesignAndSmileDesign ||
                                                currentWindowWidth <= 1200
                                            }
                                            sectionsCommonHeight={sectionsCommonHeight}
                                            isShowSmileDesignFeature={isShowSmileDesignFeature}
                                            iframeStyle={trioIDesignIframeStyle}
                                        />
                                    </Grid>
                                )}
                            </>
                        )}

                        {/* Comments */}
                        {!showCondition_ISC && // Hide the section from 2nd position and add on 3rd on this(IDesign + Comment + Smile) on because on this condition we should match this layout (IDesign + Smile + Comment)
                            !showCondition_CS &&
                            !showCondition_PSC &&
                            !showCondition_PICS && (
                                <>
                                    {(comment || showChatbox) && (
                                        <Grid
                                            item
                                            style={{overflowY: 'auto',width: '100%',...commentSidebarGridStyle}}
                                            ref={sidebarRef}
                                        >
                                            {comment && (
                                                <Box ref={commentBoxScrollRef}>
                                                    {isShowRequestUpgradeButton && renderRequestUpgradeButton()}
                                                    <div >
                                                        <RequestComment
                                                            currentTreatmentPlan={currentTreatmentPlan}
                                                            handleCurrentTreatmentPlan={handleCurrentTreatmentPlan}
                                                            handleApproveTreatmentPlanByCaseType={
                                                                handleApproveTreatmentPlanByCaseType
                                                            }
                                                            treatmentPlans={treatmentPlan}
                                                            patientInfo={patientInfo}
                                                        />
                                                    </div>
                                                </Box>
                                            )}
                                            {/* Chat-box wrapped in an accordion under the comment box */}
                                            {showChatbox && isloaded && (
                                                <Box style={{ padding: "8px 8px 0 8px" }}>
                                                    <Accordion
                                                        ref={chatboxScrollRef}
                                                        expanded={chatboxExpanded}
                                                        onChange={() => setChatboxExpanded((prev) => !prev)}
                                                    >
                                                        <StyledAccordionSummary
                                                            style={{
                                                                backgroundColor: '#e9e9e9ff',
                                                                fontWeight: 600,
                                                                borderRadius: '4px 4px 0 0',
                                                                boxShadow: 'none',
                                                                display:'flex',
                                                                alignItems:"center",
                                                                justifyContent:"center"
                                                            }}
                                                            expandIcon={<MdKeyboardArrowDown />}
                                                        >
                                                            <Badge
                                                                className={chatStyle.customBadge}
                                                                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                                badgeContent={total}
                                                            >
                                                                <Typography style={{ fontSize: 15 }}>
                                                                    {get('@PatientInfo.clinicalSimulation.buttons.openLiveSupport')}
                                                                </Typography>
                                                            </Badge>
                                                            <Tooltip
                                                                title={
                                                                    <div style={{ margin: 10 }}>
                                                                        <div style={{ fontSize: '15px', lineHeight: '1' }}>
                                                                            {get('@PatientInfo.clinicalSimulation.modal.openLiveSupportTip')}
                                                                        </div>
                                                                    </div>
                                                                }
                                                            >
                                                            <InfoIcon className="openLiveSupportTip"/>
                                                        </Tooltip>
                                                        </StyledAccordionSummary>
                                                        <AccordionDetails
                                                            style={{ padding: 0 }}
                                                        >
                                                            <Chatbox
                                                                showChatbox={showChatbox}
                                                                draggable={draggable}
                                                                hideTabs={hideTabs}
                                                                caseId={caseId}
                                                                patientId={patientId}
                                                                handleNewChatRoom={handleNewChatRoom}
                                                                handleSmallChatRoom={handleSmallChatRoom}
                                                                chatRomWidth={chatRomWidth}
                                                                dragableChatRoom={dragableChatRoom}
                                                                exitFullScreen={exitFullScreen}
                                                                handleFullScreen={handleFullScreen}
                                                                dragPosition={dragPosition}
                                                                currentTreatmentPlan={currentTreatmentPlan}
                                                                threeDimensionLink={threeDimensionLink}
                                                                handleVerticalSplit={handleVerticalSplit}
                                                                hideSimulation={hideSimulation}
                                                                currentUserRole={currentUserRole}
                                                                socketRef={socketRef}
                                                                chatRoomMessages={chatRoomMessages}
                                                                privateChatMessages={privateChatMessages}
                                                                intlChatMessages={intlChatMessages}
                                                                loadingMessages={loadingMessages}
                                                            />
                                                        </AccordionDetails>
                                                    </Accordion>
                                                </Box>
                                            )}
                                        </Grid>
                                    )}
                                </>
                            )}

                        {/* On switch treatment plan change the component positions */}
                        {!switchPositionOfiDesignAndSmileDesign ? (
                            <>
                                {/* Smile Design */}
                                {isShowSmileDesignFeature && (
                                    <Grid item>
                                        <SmileDesignPlan
                                            useStyles={useStyles}
                                            currentTreatmentPlan={currentTreatmentPlan}
                                            patientInfo={patientInfo}
                                            commentSidebarGridStyle={smileDesignPlanGridStyle}
                                        />
                                    </Grid>
                                )}
                            </>
                        ) : (
                            <>
                                {/* Trio IDesign */}
                                {showTrioIDesign && (
                                    <Grid
                                        item
                                        style={{
                                            padding: 0,
                                        }}
                                    >
                                        <TrioIDesign
                                            caseId={caseId}
                                            patientInfo={patientInfo}
                                            currentTreatmentPlan={currentTreatmentPlan}
                                            iDesignTwoShowDownloadBtn={iDesignTwoShowDownloadBtn}
                                            threeDimensionLink={threeDimensionLink}
                                            useStyles={useStyles}
                                            currentUserRole={currentUserRole}
                                            isTopPositionNormal={
                                                showCondition_I ||
                                                !threeDimensionLink ||
                                                switchPositionOfiDesignAndSmileDesign ||
                                                currentWindowWidth <= 1200
                                            }
                                            sectionsCommonHeight={sectionsCommonHeight}
                                            switchTrioIDesignstyle={trioIDesignContainerStyle}
                                            isShowSmileDesignFeature={isShowSmileDesignFeature}
                                            iframeStyle={trioIDesignIframeStyle}
                                        />
                                    </Grid>
                                )}
                            </>
                        )}

                        {/* Comments(Hide the section from 2nd position and add on 3rd for match this layout (IDesign + Smile + Comment) or (Comment + Smile)) */}
                        {(showCondition_ISC || showCondition_CS || showCondition_PSC || showCondition_PICS) && (
                            <>
                                {(comment || showChatbox) && (
                                    <Grid
                                        item
                                        style={{overflowY: 'auto',width: '100%',...commentSidebarGridStyle}}
                                        ref={sidebarRef}
                                    >
                                        {comment && (
                                            <Box ref={commentBoxScrollRef}>
                                                {isShowRequestUpgradeButton && renderRequestUpgradeButton()}
                                                <div >
                                                    <RequestComment
                                                        currentTreatmentPlan={currentTreatmentPlan}
                                                        handleCurrentTreatmentPlan={handleCurrentTreatmentPlan}
                                                        handleApproveTreatmentPlanByCaseType={
                                                            handleApproveTreatmentPlanByCaseType
                                                        }
                                                        treatmentPlans={treatmentPlan}
                                                        patientInfo={patientInfo}
                                                    />
                                                </div>
                                            </Box>
                                        )}
                                        {/* Chat-box wrapped in an accordion under the comment box */}
                                        {showChatbox && isloaded && (
                                            <Box style={{ padding: "8px 8px 0 8px" }}>
                                                <Accordion
                                                    expanded={chatboxExpanded}
                                                    onChange={() => setChatboxExpanded((prev) => !prev)}
                                                >
                                                    <StyledAccordionSummary
                                                        style={{
                                                            backgroundColor: '#e9e9e9ff',
                                                            fontWeight: 600,
                                                            borderRadius: '4px 4px 0 0',
                                                            boxShadow: 'none',
                                                            display:'flex',
                                                            alignItems:"center",
                                                            justifyContent:"center"
                                                        }}
                                                        expandIcon={<MdKeyboardArrowDown />}
                                                        ref={chatboxScrollRef}
                                                    >
                                                        <Badge
                                                            className={chatStyle.customBadge}
                                                            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                            badgeContent={total}
                                                        >
                                                            <Typography style={{ fontSize: 15 }}>
                                                                {get(
                                                                    '@PatientInfo.clinicalSimulation.buttons.openLiveSupport'
                                                                )}
                                                            </Typography>
                                                        </Badge>
                                                        <Tooltip
                                                            title={
                                                                <div style={{ margin: 10 }}>
                                                                    <div style={{ fontSize: '15px', lineHeight: '1' }}>
                                                                        {get('@PatientInfo.clinicalSimulation.modal.openLiveSupportTip')}
                                                                    </div>
                                                                </div>
                                                            }
                                                        >
                                                            <InfoIcon className="openLiveSupportTip"/>
                                                        </Tooltip>
                                                    </StyledAccordionSummary>
                                                    <AccordionDetails
                                                        style={{ padding: 0 }}
                                                    >
                                                        <Chatbox
                                                            showChatbox={showChatbox}
                                                            draggable={draggable}
                                                            hideTabs={hideTabs}
                                                            caseId={caseId}
                                                            patientId={patientId}
                                                            handleNewChatRoom={handleNewChatRoom}
                                                            handleSmallChatRoom={handleSmallChatRoom}
                                                            chatRomWidth={chatRomWidth}
                                                            dragableChatRoom={dragableChatRoom}
                                                            exitFullScreen={exitFullScreen}
                                                            handleFullScreen={handleFullScreen}
                                                            dragPosition={dragPosition}
                                                            currentTreatmentPlan={currentTreatmentPlan}
                                                            threeDimensionLink={threeDimensionLink}
                                                            handleVerticalSplit={handleVerticalSplit}
                                                            hideSimulation={hideSimulation}
                                                            currentUserRole={currentUserRole}
                                                            socketRef={socketRef}
                                                            chatRoomMessages={chatRoomMessages}
                                                            privateChatMessages={privateChatMessages}
                                                            intlChatMessages={intlChatMessages}
                                                            loadingMessages={loadingMessages}
                                                        />
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Box>
                                        )}
                                    </Grid>
                                )}
                            </>
                        )}
                    </>
                </Grid>
            </div>
            <ConfirmDialog
                title="Process Next?"
                open={confirmOpenNextAligner}
                setOpen={(val) => handleProcessNextSet(val)}
                onConfirm={() => handleChangeStatusUpdate('NEXT_SET_REQUEST')}
            >
                {get('clinicalSimulation.msg.nextSet')}
            </ConfirmDialog>
            <ClinicalRequestModal setModelOpen={setRequestModalOpen} modelOpen={requestModalOpen} caseId={caseId} />
        </Box>
    );
}

export default withRouter(ClinicalSimulation);
